<template>
  <el-dialog
    :visible.sync="resumeFlag.flag"
    show-close
    title="请选择简历"
    custom-class="cloudBody"
  >
    <span style="font-weight: bold">简历列表</span>
    <el-table
      :data="resumeList"
      highlight-current-row
      @current-change="handleCurrentChange"
    >
      <el-table-column property="resumename" label="简历名称"></el-table-column>
      <el-table-column property="resumecompl" label="完成度"
        ><template slot-scope="scope">
          <el-progress
            :text-inside="true"
            :stroke-width="20"
            :percentage="scope.row.resumecompl"
          ></el-progress> </template
      ></el-table-column>
      <el-table-column property="modifytime" label="编辑时间"></el-table-column>
    </el-table>

    <div slot="footer" class="dialog-footer">
      <el-button @click="addNewResume" type="primary" class="addNewResume"
        >新增简历</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { myResume } from "../request/resumeApi";
import { mapState } from "vuex";

export default {
  name: "resumeList",
  props: {
    resumeFlag: {
      type: Object,
      default: () => {
        return {};
      },
    },
    backRoute: {
      Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      resumeList: [],
    };
  },
  methods: {
    //我的简历列表
    getResume() {
      let params = {};
      myResume(params).then((res) => {
        if (res.code == "1") {
          this.resumeList = res.data;
        }
      });
    },
    //选中简历行
    handleCurrentChange(val) {
      this.resumeFlag.flag = false;
      var route = {
        back: {
          path: this.$props.backRoute.path,
        },
        forward: {
          path: "/personInfo",
          query: {
            oid: val.oid,
            soid: val.soid,
            VOStatus: "view",
          },
        },
      };

      this.$store.commit("pushBackRoute", route.back);
      this.$router.push(route.forward);
    },
    //新增简历
    addNewResume() {
      this.resumeFlag.flag = false;
      var route = {
        back: this.$props.backRoute,
        forward: { path: "/personInfo?VOStatus=new" },
      };
      this.$store.commit("pushBackRoute", route.back);
      this.$router.push(route.forward);
    },
  },
  mounted() {
    this.getResume();
  },
  computed: {
    ...mapState(["resumeSelectData"]),
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  .addbtn {
    float: left;
  }
}
.tip3 {
  color: red;
  font-size: 14px;
  margin-top: 15px;
  display: inline-block;
  line-height: 30px;
}
@media screen and (max-width: 992px) {
  ::v-deep .el-dialog.cloudBody {
    width: 80%;
  }
  li {
    margin: 10px;
  }
}
@media screen and (max-width: 576px) {
  ::v-deep .el-dialog.cloudBody {
    width: 80%;
  }
  ::v-deep .el-button.addNewResume {
    pointer-events: none;
    opacity: 0.5;
  }
  li {
    margin: 10px;
  }
}
</style>
